import { useMemo } from "react";
import { useSearchParams } from "react-router";
import type { GroupType, SearchParamsType } from "../ComparativeAnalysisForm.types";
import { deserializeFormParams } from "../ComparativeAnalysisForm.utils";
import { parseTask } from "../components/ComparativeAnalysisFormTask/ComparativeAnalysisFormTask.utils";

// returns the URL search-params groups as an object
export const useSearchParamsGroups = () => {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const flat = deserializeFormParams(searchParams);
    const group1: GroupType = {
      env: flat.env1,
      pipeline: flat.pipeline1,
      pit: flat.pit1,
      task: flat.task1,
    };
    const group2: GroupType = {
      env: flat.env2,
      pipeline: flat.pipeline2,
      pit: flat.pit2,
      task: flat.task2,
    };
    return { group1, group2 };
  }, [searchParams]);
};

// get the flat-object of the relevant search-params (related to the form)
export const useComparativeAnalysisSearchParams = (): Partial<SearchParamsType> => {
  const [searchParams] = useSearchParams();

  return useMemo(() => deserializeFormParams(searchParams), [searchParams]);
};

/**
 * Returns the task IDs from the search params
 */
export const useGetComparedTasks = () => {
  const { group1, group2 } = useSearchParamsGroups();
  return [parseTask(group1.task), parseTask(group2.task)];
};
